// ⚠ import 顺序要紧，别调换：
//   wechat-callback 在**模块求值时**就把 ?wechat_token= 从地址栏摘下来，并把 hash
//   改写成目标路由；而 vue-router 的构造函数会读写地址栏（replaceState 成 #/xxx，
//   顺带抹掉查询串）。ES 模块按 import 顺序求值，所以本模块必须排在 './router' 之前。
import { consumeWechatCallback } from './components/shared/wechat-callback'
import { authSession } from './components/shared/runtime'
import { restorePaymentReturn, paymentReturn } from './components/shared/payment-return'
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import './components/shared/platform.css'
import './components/shared/editorial.css'
import './components/shared/ui-polish.css'
// 顾客端新主题：仅在 html.lx-on 下生效，管理后台不受影响
import './components/shared/lx-theme.css'
import './components/shared/consumer-ui.css'
import './components/admin/admin-theme.css'

Vue.config.productionTip = false

// 第二光源平台前端统一使用 ElementUI（Vue2 版本）
Vue.use(ElementUI, { size: 'medium', zIndex: 3000 })

async function start() {
  await authSession.restore()
  await restorePaymentReturn()
  if (paymentReturn.orderId || paymentReturn.error) await Promise.resolve(router.replace('/recharge')).catch(() => {})
  const result = await consumeWechatCallback()
  new Vue({ router, render: h => h(App) }).$mount('#app')
  if (result && !result.ok) Promise.resolve(router.replace(result.route || '/login')).catch(() => {})
}
start()
